import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { ExerciseModel } from 'projects/core/src/lib/models/exercise.model';
import { ExerciseversionModel } from 'projects/core/src/lib/models/exerciseversion.model';

@Component({
  selector: 'app-exercise-versions',
  templateUrl: './exercise-versions.component.html',
  styleUrls: ['./exercise-versions.component.scss']
})
export class ExerciseVersionsComponent implements OnInit {

  @Input() exercise: ExerciseModel = null;

  constructor(
    private router: Router,
    private auth: AuthStateService,
  ) { }

  ngOnInit(): void {
  }

  public openVersion(version: ExerciseversionModel): void {
    if (this.auth.hasRight('admin.exercise.show')) {
      localStorage.setItem('exercise-tab-' + this.exercise.id, null);
      this.router.navigate(['/exercises', this.exercise.id, version.hashed_id]);
    }
  }

}
